<div>
  <h1 class="dsd-t-6" data-cy="boite_aide_title">{{ 'boite-aide.titre' | translate }}</h1>
  <hr />
  <p class="dsd-mb-sm">{{ 'boite-aide.texte' | translate }}</p>
  <app-boite-contact isDSD="true" buttonStyle="textAndIcon" (click)="clickToCall.emit()"></app-boite-contact>
</div>
